import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable, runInAction, reaction, when, autorun } from "mobx";
import axios from "axios";
class ColumnStore {
  id = uuidv4();
  width = 150;
  visible = true;
  filterOptions = new Map();
  selectedFilterOptions = new Set();
  allFilters = {};
  orderBy = 0;
  filteredRowIds = new Set();
  commonColumnMap = new Map();
  constructor(title, width = 150, filterOptions = []) {
    this.title = title;
    this.width = width;
    this.filterOptions = filterOptions;
    // this.offset = 0;
    // this.limit = 50;
    // this.commonFlag = 0;
    makeAutoObservable(this);
    // Initialize state via setter
    this.setCommonRowValues = {
      searchTerm: "",
      filterAnchorEl: null,
      menuAnchorEl: null,
      isFilterMenuOpen: false,
      isRenaming: false,
      newTitle: "",
      title: "",
      offset: 0,
      limit: 100,
    };
    // Reactions for state changes
    reaction(
      () => this.getisRenaming,
      (isRenaming, prev) => {
        if (isRenaming === false && prev === true) {
          this.closeMenu();
        } else if (isRenaming === true) {
          // Handle renaming logic
        }
      }
    );
    reaction(
      () => this.isFilterMenuOpen === true,
      () => {
        if (this.filterOptions.length === 0) {
          this.fetchTableColumnValues();
        }
      }
    );
    reaction(
      () => Array.from(this.selectedFilterOptions),
      (currentOptions) => {
        this.updateFilteredRowIdsFromSelection(currentOptions);
        // this.applyTheValue({
        //   filterAnchorEl: null,
        //   isFilterMenuOpen: false,
        // });
      }
    );
    Object.entries(this.setCommonRowValues).forEach(([key, val]) => {
      this.commonColumnMap.set(key, val);
    });
    autorun(() => {
    })
  }
  // Getters
  get getSearchTerm() {
    return this.commonColumnMap.get("searchTerm");
  }
  get filterAnchorEl() {
    return this.commonColumnMap.get("filterAnchorEl");
  }
  get getmenuAnchorEl() {
    return this.commonColumnMap.get("menuAnchorEl");
  }
  get isFilterMenuOpen() {
    return this.commonColumnMap.get("isFilterMenuOpen");
  }
  get getisRenaming() {
    return this.commonColumnMap.get("isRenaming");
  }
  get getNewTitle() {
    return this.commonColumnMap.get("newTitle");
  }
  get getTitle() {
    return this.commonColumnMap.get("title");
  }
  get getoffset() {
    return this.commonColumnMap.get("offset"); // Get the 'offset' value from the map
  }
  get getlimit() {
    return this.commonColumnMap.get("limit"); // Get the 'limit' value from the map
  }
  updateFilteredRowIdsFromSelection(selectedOptions) {
    runInAction(() => {
      this.filteredRowIds.clear();
      selectedOptions.forEach((item) => {
        item.split(",").forEach((id) => {
          if (id.trim()) {
            this.filteredRowIds.add(id.trim());
          }
        });
      });
    });
  }
  applyTheValue(updates) {
    runInAction(() => {
      for (const [key, value] of Object.entries(updates)) {
        this.commonColumnMap.set(key, value);
      }
    });
  }
  closeMenu = () => {
    this.setCommonRowValues = { menuAnchorEl: null };
  };
  setId(id) {
    this.id = id;
  }
  setOrderBy(order) {
    this.orderBy = order;
  }
  setWidth(width) {
    this.width = Math.max(50, width);
  }
  toggleVisibility() {
    this.visible = !this.visible;
  }
  toggleFilterOption(option) {
    runInAction(() => {
      const selected = new Set(this.selectedFilterOptions);
      if (selected.has(option)) {
        selected.delete(option);
      } else {
        selected.add(option);
      }
      this.selectedFilterOptions = selected;
    });
  }
  async fetchFilterOptions(tableId, userId, columnName) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_EXPERIAN_API}/experian/getTableColumnValues`,
        {
          tableId,
          userId,
          columnName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      runInAction(() => {
        this.filterOptions = response?.data?.data ?? [];
      });
    } catch (error) { }
  }
  clearFilters() {
    this.selectedFilterOptions = new Set();
    this.searchTerm = "";
  }
  setRootStore(rootStore) {
    this.rootStore = rootStore;
  }
  isOptionSelected(option) {
    return this.selectedFilterOptions.has(option);
  }
  get filteredOptions() {
    const options = Array.isArray(this.filterOptions) ? this.filterOptions : [];
    const term = this.searchTerm?.trim().toLowerCase();
    if (!term) return options;
    return options.filter((opt) => opt.toLowerCase().includes(term));
  }
  async fetchTableColumnValues() {
    if (this.isFetching) return; // prevent parallel calls
    this.isFetching = true;
    try {
      const response = await this.rootStore.commonAxios(
        "/getTableColumnValues",
        "POST",
        {},
        {
          tableId: this.rootStore.gridStore.tabIndex === 0 ? this.rootStore.gridStore.tableCompanyId : this.rootStore.gridStore.tablePeopleId,
          userId: this.rootStore.gridStore.userId,
          columnName: this.id,
          offset: this.getoffset, // Using getter here for dynamic access
          limit: this.getlimit, // Using getter here for dynamic access
          search: this.getSearchTerm,
        },
        {
          "Content-Type": "application/json",
        }
      );
      const list = response?.data?.list || [];
      if (list.length > 0) {
        runInAction(() => {
          this.filterOptions = [...list];
          // this.applyTheValue({ offset: this.getoffset + this.getlimit });
        });
      }
      return true;
    } catch (error) {
      throw error;
    } finally {
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
}
export default ColumnStore;
